import React from 'react';
import '../styles/Panel.css';

const Panel = ({ title, children, className = '' }) => {
  return (
    <div className="panel">
      {title && <div className="panel-heading">
        <h3 className="panel-title">{title}</h3>
      </div>}
      <div className="elegant-aero">
        {children}
      </div>
    </div>
  );
};

export default Panel;